import Login from "./Login";
import Protected from "./Protected";
import Logout from "./Logout";

export default { Login, Protected, Logout };
